import { z } from "zod";

// GET request Schemas //

export const TruckPayMarkupSchema = z.object({
	start: z.number(),
	end: z.number(),
	markup: z.number(),
	minimum: z.number().nullable(),
	maximum: z.number().nullable(),
	type: z.enum(["FLAT", "PERCENTAGE"]),
});

// Endpoint: /api/carrier-selection/markupdefaults/partials
// Endpoint: /api/carrier-selection/insurance-markup?legacyId={:legacyId}&carrierId={:carrierId}
export const MarkupsPartialsSchema = z.object({
	customerId: z.number().nullable(),
	overrideDefaultTruckPayMarkups: z.boolean(),
	truckPayMarkups: z.array(TruckPayMarkupSchema),
	userCanEdit: z.boolean(),
});

export const AccessorialMarkupSchema = z.object({
	accessorialCode: z.string(),
	markup: z.number().nullable(),
	notRated: z.boolean(),
});

// Endpoint: /api/carrier-selection/markupdefaults/ltl?customerId={:customerId}
// Endpoint: /api/carrier-selection/insurance-markup?legacyId={:legacyId}&carrierId={:carrierId}
export const MarkupsSchema = z.object({
	standardMarkupCalculationType: z.string(),
	volumeMarkupCalculationType: z.string(),
	standardMarkups: z.array(TruckPayMarkupSchema),
	volumeMarkups: z.array(TruckPayMarkupSchema),
	standardAccessorialMarkups: z.array(AccessorialMarkupSchema),
	volumeAccessorialMarkups: z.array(AccessorialMarkupSchema),
	carrierSpecificMarkups: z.array(z.unknown()),
});

export type AccessorialMarkup = z.infer<typeof AccessorialMarkupSchema>;
export type TruckPayMarkup = z.infer<typeof TruckPayMarkupSchema>;
export type MarkupsPartials = z.infer<typeof MarkupsPartialsSchema>;
export type Markups = z.infer<typeof MarkupsSchema>;
